import React from 'react';

const Footer = () => {
  return (
    <>
      {/* Light gray divider at the boundary, full width, outside the white footer */}
      <div style={{ width: '100vw', height: 2, background: '#e5e7eb', marginLeft: 'calc(50% - 50vw)', marginRight: 'calc(50% - 50vw)' }} />
      <footer className="w-full bg-white pt-2 pb-4 px-4 sm:px-6 lg:px-8 mt-auto text-left">
        <div>
          <h3 className="text-lg font-semibold" style={{ color: '#8034c4' }}>
            Legal
          </h3>
          <ul className="mt-1.5 space-y-[0.09375rem]">
            <li>
              <a
                href="https://www.guidedementia.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-600 hover:underline"
                style={{ transition: 'color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.color = '#8034c4'}
                onMouseLeave={e => e.currentTarget.style.color = ''}
              >
                Terms and Conditions
              </a>
            </li>
            <li>
              <a
                href="https://www.guidedementia.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-600 hover:underline"
                style={{ transition: 'color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.color = '#8034c4'}
                onMouseLeave={e => e.currentTarget.style.color = ''}
              >
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </>
  );
};

export default Footer;
